<mat-toolbar class="ppw-toolbar" color="primary">
    <mat-toolbar-row fxLayoutAlign="space-between center">
        <div>
            <button *ngIf="showMenu" mat-icon-button (click)="toggleLeftMenu()">
                <mat-icon class="material-icons">menu</mat-icon>
            </button>
            <ng-content *ngIf="hasIconLeft" select="iconleft"></ng-content>
            <span class="toolbar-title">{{ menuTitle }}</span>
        </div>

        <ng-content select="speeddialbuttons" fxShow="false" fxShow.gt-xs="true"></ng-content>

        <ng-content select=".my-trans-icons-buttons"></ng-content>

        <ng-content select=".ppw-speed-dial-position"></ng-content>
    </mat-toolbar-row>
</mat-toolbar>
